import { type APIKeyAndToken, issueAPIKeyAndToken } from '@app/components/Chat/actions'
import Chat from '@app/components/Chat/Chat'
import { IDispatchProps } from '@app/components/EditPageContainer/EditPageContainer'
import { ICurrentUserState } from '@app/store/modules/account'
import * as React from 'react'

type IComponentProps = ICurrentUserState & IDispatchProps

const ChatPage = ({ user, errorToast }: IComponentProps) => {
  const [chatAPIKeyAndToken, setChatAPIKeyAndToken] = React.useState<APIKeyAndToken | null>(null)

  React.useEffect(() => {
    if (!user) {
      return
    }
    issueAPIKeyAndToken()
      .then((response) => {
        if (response instanceof Error) {
          throw new Error(response.message ?? 'Failed to issue token')
        }
        setChatAPIKeyAndToken(response)
      })
      .catch((err) => {
        errorToast(
          'Oops!',
          `Failed to connect to chat. Try again in a few minutes or submit a bug report if it's still not working.\n\nError: ${(err as Error).message}`,
        )
      })
  }, [user, errorToast])

  if (!user) {
    return (
      <div>
        <p>You must be logged in to access chat features.</p>
      </div>
    )
  }

  if (!chatAPIKeyAndToken) {
    return null
  }

  return (
    <Chat
      apiKey={chatAPIKeyAndToken.apiKey}
      chatToken={chatAPIKeyAndToken.token}
      userData={{
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
      }}
      onError={(err) => {
        errorToast('Oops!', err.message)
      }}
    />
  )
}

export default ChatPage
